var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPropertyPlaceholder = function SvgPropertyPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 252 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.439453,
    width: 251.56,
    height: 174,
    rx: 8,
    fill: "#171717"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4251_4539)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M143.439 186.455V86.3946C143.439 65.2161 161.862 48 184.523 48H225.356C248.002 48 266.439 65.2161 266.439 86.3946V186.455H170.771V92.73C170.789 87.6361 172.96 82.7564 176.808 79.1604C180.656 75.5643 185.867 73.5451 191.3 73.5451H218.573C224.006 73.5451 229.217 75.5643 233.065 79.1604C236.913 82.7564 239.084 87.6361 239.102 92.73V161.677H198.106V99.0269H211.77V148.915H225.436V92.73C225.432 91.0271 224.707 89.3953 223.421 88.193C222.135 86.9907 220.392 86.3162 218.576 86.3176H191.303C189.487 86.3162 187.744 86.9907 186.458 88.193C185.172 89.3953 184.447 91.0271 184.443 92.73V174.45H252.773V86.3946C252.773 72.2692 240.471 60.7725 225.356 60.7725H184.523C169.405 60.7725 157.105 72.2692 157.105 86.3946V199.995H266.439V212H143.439V186.455Z",
    fill: "url(#paint0_radial_4251_4539)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4251_4539",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(364.337 246.078) rotate(-143.619) scale(378.826 398.268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF303D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073EEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4251_4539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 251.56,
    height: 174,
    fill: "white",
    transform: "translate(0.439453)"
  })))));
};
export default SvgPropertyPlaceholder;